/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase, fontSize, enterpriseCSS,
} from './variables';

// fix: SSP-1626 normalized css for account mfe [skip ci]
export const DeliveryHoursStyle = (typography, palette) => ({
    // Delivery Hours
    DeliveryHoursStyle: {
        border: `2px solid ${palette.grey7}`,
        borderRadius: '4px',
        padding: `${unitBase * 2}px`,
        display: 'flex',
        alignItems: 'center',
        fontSize: fontSize.small,
        justifyContent: 'space-between',
        width: '100%',
        '&.shadowStyle': {
            boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
        },
        '& svg': {
            paddingRight: unitBase,
        },
        '& .deliveryLabel': {
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            fontWeight: 700,
            color: palette.grey4,
            '& svg': {
                verticalAlign: 'middle',
                width: '24px',
            },
        },
        '& > div': {
            '& > div': {
                display: 'inline-block',
                lineHeight: '16px',
            },
            '& > svg': {
                color: enterpriseCSS.palette.gray2,
                width: '16px',
            },
        },
    },
});
